import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: 'home'
          }
        }, {
          path: '/about-us',
          name: 'about-us',
          component: resolve => require(['@/view/AboutUs'], resolve),
          meta: {
            title: 'about-us'
          }
        }, {
          path: '/day-care-service',
          name: 'dayCareService',
          component: resolve => require(['@/view/DayCareService'], resolve),
          meta: {
            title: 'service'
          }
        },{
          path: '/home-care-service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: 'service'
          }
        }, {
          path: '/our-activities',
          name: 'ourActivities',
          component: resolve => require(['@/view/OurActivities'], resolve),
          meta: {
            title: 'careers'
          }
        }, {
          path: '/careers',
          name: 'careers',
          component: resolve => require(['@/view/Careers'], resolve),
          meta: {
            title: 'careers'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: 'contactus'
          }
        },
        {
          path: '/service_areas',
          name: 'service_areas',
          component: resolve => require(['@/view/ServiceArea'], resolve),
          meta: {
            title: 'service_areas'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js